import { icons } from '@chillibean/component-library/legacy';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { dateFormat } from '../../../../../__util__/dates';
import StandardCard from '../../../../../StandardCard/StandardCard';

export function FormTemplateVersionsContainer(props) {
  const { formTemplate, accountTimezone } = props;
  const history = useHistory();

  return (
    <>
      {formTemplate &&
        formTemplate.versions &&
        formTemplate.versions.map((formTemplateVersion, index) => {
          const formTemplateVersionNumber = formTemplateVersion.version_number?.toString();
          return (
            <StandardCard
              customStyle={{ color: '#b1b3b4' }}
              key={index}
              title={`Version ${formTemplateVersionNumber}`}
              titleIcon={icons.eye(24, 24)}
              titleLink={`/${formTemplate.id}/versions/${formTemplateVersion.version_number}`}
              active
              clickHandler={() => history.push(`/${formTemplate.id}/versions/${formTemplateVersion.version_number}`)}
            >
              <span>{dateFormat(formTemplateVersion.created_at, { timezone: accountTimezone })}</span>
              <span>{formTemplateVersion.created_by.email}</span>
              <span>Fields: {formTemplateVersion.fields.length}</span>
            </StandardCard>
          );
        })}
    </>
  );
}

StandardCard.propTypes = {
  formTemplate: PropTypes.object,
  accountTimezone: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    accountTimezone: state.internalReducer.internal.accountTimezone,
  };
};

export default connect(mapStateToProps)(FormTemplateVersionsContainer);
